import { configureStore } from "@reduxjs/toolkit";
import menuReducer from "./menu/menu.slice";

const rootReducer = {
    menu: menuReducer,
};

const store = configureStore({
    reducer: rootReducer,
});

export default store;
